import { render, staticRenderFns } from "./PageProductTable.vue?vue&type=template&id=d9c04406"
import script from "./PageProductTable.vue?vue&type=script&lang=js"
export * from "./PageProductTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports